<template>
    <div id="detail">
        <div class="smallContent miscContent">
            <img :src="item.image" id="mainImage" alt="" />

            <div id="infos">

                <div class="text">{{ item.title }}</div>
                <div class="text" v-html="item.description"></div>

                <div id="playlist">
                    <template v-for="(track, index) in trackList.items">
                        <router-link :to="{ name: 'detail', params: { id: track.pk } }" v-if="track.playing == true"
                            class="activeItem playlistItem" :class="{ desktop: $mq != 'sm' }">
                            <img :src="item.small_thumbnail" alt="" />
                            <img id="play" v-if="isPlaying(item.pk, item.type)" @click.prevent.stop="setPause" :src="isHovering
                                ? '/static/new_icons/pause-player_hover.svg'
                                : '/static/icons/pause-player.svg'
                                " @mouseover="isHovering = true" @mouseout="isHovering = false" />

                            <img id="play" v-else @click.prevent.stop="setPlay(item)" :src="isHovering
                                ? '/static/new_icons/play-player-large_hover.svg'
                                : '/static/icons/play-player-large.svg'
                                " @mouseover="isHovering = true" @mouseout="isHovering = false" />
                            <!-- <div -->
                            <!--     v-if=" -->
                            <!--         store.privatePlayerItem.type == 'playlist' && -->
                            <!--             store.privatePlayerStatus == 'unpaused' -->
                            <!--     " -->
                            <!-- > -->
                            <!--     PAUSE -->
                            <!-- </div> -->
                            <div v-if="$mq == 'sm'" id="title" class="activeItem">
                                <div>
                                    <span>Now Playing: </span>

                                    <span>{{ track.artist }}</span>
                                    <span> {{ track.title }}</span>
                                </div>
                            </div>
                            <div v-else id="title" class="activeItem">
                                <div>
                                    <span>Now Playing: </span>
                                    <span v-if="track.artist && track.title">{{ track.artist }}:
                                        {{ track.title }}</span>
                                    <span v-else-if="track.artist && !track.title">{{ track.artist }}</span>
                                    <span v-else>{{ track.title }}</span>
                                </div>
                            </div>
                        </router-link>
                    </template>
                    <template v-for="(track, index) in trackList.items">
                        <router-link :to="{ name: 'detail', params: { id: track.pk } }" class="playlistItem" :class="{
                            desktop: $mq != 'sm',
                            activeTrack: track.playing == true,
                        }">
                            <img :src="track.small_thumbnail" alt="" />
                            <div id="title" class="mobile" v-if="$mq == 'sm'">
                                <span>
                                    {{ track.title }}
                                </span>
                                <span>
                                    {{ track.artist }}
                                </span>
                                <span id="titleLocation">
                                    <span class="playlistDate" v-html="formatDate(track.start_time)"></span>
                                    <span v-if="track.venue">
                                        {{ track.venue }}
                                    </span>
                                    <span v-if="track.city">
                                        {{ track.city }}
                                    </span>
                                </span>
                            </div>
                            <div v-else id="title" class="desktop">
                                <span class="playlistDate" v-html="formatDate(track.start_time)"></span>
                                <span v-html="track.artist"> </span>
                                <span v-html="track.title"> </span>
                                <span>{{ track.venue }}</span>
                                <span class="city">{{ track.city }}</span>
                            </div>
                        </router-link>
                    </template>
                </div>
            </div>

        </div>
        <Footer></Footer>
    </div>
</template>

<script>
import axios from "axios";
import { store } from "../store";
import Footer from "./Footer.vue";
import { DateTime } from "luxon";

export default {
    name: "StreamDetail",
    components: {
        Footer,
    },
    data() {
        return {
            item: {
                pk: 0,
                image: "",
                title: "",
            },
            store: store,
            isHovering: false,
            archiveLinkHover: false,
        };
    },
    computed: {
        trackList() {
            return this.store.streams.find(
                (stream) => stream.pk == this.item.pk
            );
        },
    },
    methods: {
        setPause() {
            this.store.privatePlayerStatus = "paused";
            this.pauseHover = false;
        },

        isPlaying(pk, type) {
            if (
                store.privatePlayerItem.type == type &&
                store.privatePlayerItem.pk == pk &&
                store.privatePlayerStatus == "playing"
            ) {
                return true;
            }
        },
        setPlay(item) {
            this.store.privatePlayerItem = this.item;
            this.store.privatePlayerItemID = this.item.pk;
            this.store.privatePlayerVisible = true;
            this.store.privatePlayerChanged = true;
            this.store.privatePlayerStatus = "unpaused";
        },
        formatDate(date) {
            return DateTime.fromISO(date)
                .setLocale("en-US")
                .toFormat("MM/dd/yy");
        },
    },

    mounted: function () {
        axios
            .get("/api/get-stream/" + this.$route.params.slug)
            .then((response) => {
                this.item = response.data;
            });

        window.scrollTo(0, 0);
    },
};
</script>

<style scoped>
#detail {
    margin: 1rem;
    max-width: 100%;
}

/* @media only screen and (min-width: 1101px) { */
/*     #detail { */
/*         max-width: 66%; */
/*     } */
/* } */

/* @media only screen and (min-width: 1440px) { */
/*     #detail { */
/*         max-width: 50%; */
/*     } */
/* } */

/* @media only screen and (min-width: 1900px) { */
/*     #detail { */
/*         max-width: 33%; */
/*     } */
/* } */

#mainImage {
    width: 100%;
    aspect-ratio: 1 / 1;
    /* min-width: calc(100vw - 2rem); */
    /* min-height: calc(100vw - 2rem); */
    background-color: #fcfac4;
}

#mainImage.LI {
    background-color: #8dd9fc;
}

#mainImage.IS {
    background-color: #f6b2c6;
}

#mainImage.IR {
    background-color: #f6b2c6;
}

#mainImage.RE {
    background-color: #9fe1a7;
}

#mainImage.NY {
    background-color: #fcfac4;
}

/* @media only screen and (min-width: 1101px) { */
/*     #mainImage { */
/*         min-width: calc(66vw - 2rem); */
/*         max-width: calc(66vw - 2rem); */
/*         min-height: calc(66vw - 2rem); */
/*     } */
/* } */

/* @media only screen and (min-width: 1440px) { */
/*     #mainImage { */
/*         min-width: calc(50vw - 2rem); */
/*         max-width: calc(50vw - 2rem); */
/*         min-height: calc(50vw - 2rem); */
/*     } */
/* } */

/* @media only screen and (min-width: 1900px) { */
/*     #mainImage { */
/*         min-width: calc(33vw - 2rem); */
/*         max-width: calc(33vw - 2rem); */
/*         min-height: calc(33vw - 2rem); */
/*     } */
/* } */

#play,
#add {
    cursor: pointer;
    display: flex;
}

.buttonImage,
.buttonSpacer {
    width: 1.8rem;
    min-width: unset;
    min-height: unset;
    background-color: transparent;
}

.buttonText {
    flex-grow: 1;
}

#location span:first-child {
    margin-right: 1rem;
}

#location {
    margin-bottom: 0.7rem;
}

#time {
    margin-bottom: 1.4rem;
}

#date {
    margin-top: 0.3rem;
}

#date,
#time {
    font-variant-numeric: tabular-nums;
    font-feature-settings: "tnum" on;
}

.text {
    width: min(750px, 100%);
    padding-right: 2rem;
    box-sizing: border-box;
}

.text>>>a {
    color: #aaaaaa;
}

#links .text {
    margin-bottom: 0;
}

#links a {
    color: #aaaaaa;
}

#links a:hover {
    color: black;
}

#audio {
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-bottom: 0.7rem;
}

@media only screen and (min-width: 738px) {
    #audio {
        flex-direction: row;
    }
}

#audio>div {
    border: 1px solid black;
    text-align: center;
    padding: 0.65rem 1rem 0.85rem;
    margin-bottom: 1rem;
}

#audio>div:last-of-type {
    margin-bottom: 0;
}

#audio>div:hover {
    background-color: black;
    color: white;
}

@media only screen and (min-width: 738px) {
    #audio>div {
        width: 50%;
        margin-left: 0.5rem;
        margin-bottom: 0;
    }

    #audio>div:first-child {
        margin-left: 0;
        margin-right: 1rem;
    }
}

#infos {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    align-items: flex-start;
    margin-top: 0.6rem;
    margin-bottom: 1.6rem;
    width: calc(100vw - 2rem);
}

img#play {
    cursor: pointer;
    height: 3rem;
    width: 3rem;
    background-color: transparent;
    min-height: unset;
    min-width: unset;
    max-height: unset;
    max-width: unset;
}

.playlistItem {
    padding: 0.5rem 0rem;
    display: flex;
    gap: 1rem;
    align-items: center;
    white-space: nowrap;
    color: grey;
    font-size: 12px;
    font-family: "Montez Small";
    line-height: initial;
}

.playlistItem:last-child {
    padding-bottom: 2rem;
}

.playlistItem.desktop:last-child {
    border-bottom: 1px solid lightgrey;
}

.playlistItem.desktop {
    font-size: initial;
    font-family: "Montez Large";
    padding: 1rem 0;
    border-top: 1px solid lightgrey;
}

.playlistItem>.title {
    flex-grow: 1;
}

.playlistItem>img {
    flex-shrink: 0;
    object-fit: cover;
    height: 51px;
    width: 51px;
}

.playlistItem.desktop>img {
    height: 26px;
    width: 26px;
}

.playlistItem.activeItem {
    color: black;
    border-top: none;
}

.playlistItem.activeItem>img {
    height: 51px;
    width: 51px;
}

.playlistDate {
    font-variant-numeric: tabular-nums;
    font-feature-settings: "case" on;
}

#playlist {
    width: 100%;
}

#title {
    flex-grow: 1;
    overflow: hidden;
}

#title>* {
    overflow: hidden;
    text-overflow: ellipsis;
}

#title>.city {
    text-align: right;
}

#title.mobile {
    display: flex;
    flex-direction: column;
}

#title.desktop {
    display: grid;
    gap: 1rem;
    grid-template-columns: auto 2fr 2fr 1fr 1fr;
}

#titleLocation {
    display: flex;
    gap: 1rem;
}

#title.activeItem {
    display: flex;
    flex-direction: column;
}

.playlistItem.activeTrack {
    color: black;
}
</style>
